import { jsx as _jsx } from "react/jsx-runtime";
import { Assembler, isValidBusinessObject, QueryTypes } from '@iotv/datamodel';
import { Autocomplete, FormControl, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import ApiGateway from '../../data/aws/api-gateway/ApiGateway';
import { useDocumentClientQuery } from '../../hooks/useDocumentClientQueryV1';
import { getVOBListHash } from '../../util/AppData/viewObject';
const debug = process.env.REACT_APP_DEBUG && false;
const apiRef = 'ConsumerApi';
const noOptions = 'No options available';
const requestSetOption = 'Please set option';
export const SingleObjectAutoComplete = ({ contextObject: contextObjectIn, adjacencyType, objectTypeId: objectTypeIdIn, currentEntity, setCurrentEntity, style, fullWidth = false, dense = true, disabled = false, }) => {
    const [objectTypeId, setObjectTypeId] = React.useState(undefined);
    const [contextObject, setContextObject] = React.useState(contextObjectIn);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        debug && console.log('SingleObjectAutoComplete used effect on objectTypeId', { objectTypeId, objectTypeIdIn });
        setObjectTypeId(objectTypeIdIn);
    }, [objectTypeIdIn]);
    useEffect(() => {
        debug && console.log('SingleObjectAutoComplete used effect on currentEntity', { currentEntity });
    }, [currentEntity?.sk]);
    const queryParams = {
        ExclusiveStartKey: undefined,
        limit: 200,
        contextObject: contextObject,
        excludeRelatedToObject: undefined,
        includeEdges: false,
        includeNodes: true,
        adjacencyType,
        objectTypeId: objectTypeId,
        queryType: QueryTypes.LIST_LIMITED_ALL_TYPES,
    };
    const query = async (fn, contextRequest) => {
        if (contextRequest.objectTypeId) {
            debug && console.log('SingleObjectAutoComplete query request', contextRequest);
            try {
                setLoading(true);
                const response = await ApiGateway.post(`/query/`, contextRequest, apiRef);
                if (response.data?.Items) {
                    response.data.Items = response.data.Items.map((zombie) => Assembler.getInstance(zombie));
                }
                debug && console.log('SingleObjectAutoComplete query results', response);
                fn(response);
                setLoading(false);
            }
            catch (e) {
                debug && console.log('Error in UM query', e);
            }
        }
        else {
            debug && console.log('SingleObjectAutoComplete ignored query request', contextRequest);
        }
    };
    const queryHook = useDocumentClientQuery(query, queryParams, [contextObject, objectTypeId]);
    const [[items, setItems], [limit, setLimit], [LastEvaluatedKeys, setLastEvaluatedKeys], [ExclusiveStartKey, setExclusiveStartKey]] = queryHook.querySetterGetters;
    const notifiableEntitiesHash = getVOBListHash(items);
    useEffect(() => {
        debug && console.log('SingleObjectAutoComplete contextObject', contextObject);
        if (contextObject?.type === 'Customer')
            setContextObject(contextObject);
    }, [contextObjectIn?.sk]);
    // useEffect(() => {
    //     debug && console.log('SingleObjectAutoComplete contextObject', contextObjectIn)
    //     if (contextObjectIn?.type === 'Customer') setContextObject(contextObjectIn)
    // }, [contextObjectIn?.sk])
    useEffect(() => {
        debug && console.log('SingleObjectAutoComplete Used effect on VOB Hash', notifiableEntitiesHash);
    }, [notifiableEntitiesHash]);
    debug && console.log('objectTypeId', objectTypeId);
    const componentMap = {
        entity: (_jsx(FormControl, { fullWidth: fullWidth, children: _jsx(Autocomplete, { freeSolo: false,
                id: 'selectEntity',
                disableClearable: true,
                style,
                size: 'small',
                disabled,
                loading,
                options: loading
                    ? []
                    : items.toSorted((a, b) => a.name?.localeCompare(b.name ?? '', undefined, { numeric: true }) ?? 0),
                value: currentEntity,
                getOptionLabel: (option) => option.name ?? option.sk ?? (items.length > 0 ? requestSetOption : noOptions),
                isOptionEqualToValue: (option, value) => option.id === value.id,
                onChange: (e, v) => {
                    v && isValidBusinessObject(v) && setCurrentEntity(v);
                },
                renderInput: (params) => (_jsx(TextField, { ...params,
                    label: objectTypeId })),
                onInputChange: (e) => {
                    console.log('Input change', e);
                } }) })),
    };
    return componentMap.entity;
};
export const MultipleObjectAutoComplete = ({ contextObject: contextObjectIn, adjacencyType, objectTypeId: objectTypeIdIn, currentEntities, setCurrentEntities, closeOnSelect = true, multiple = true, style, fullWidth = false, dense = true, required = false, label, }) => {
    const [objectTypeId, setObjectTypeId] = React.useState(objectTypeIdIn);
    const [contextObject, setContextObject] = React.useState(contextObjectIn);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        debug && console.log('MultipleObjectAutoComplete used effect on objectTypeId', { objectTypeId, objectTypeIdIn });
        setObjectTypeId(objectTypeIdIn);
    }, [objectTypeIdIn]);
    const queryParams = {
        ExclusiveStartKey: undefined,
        limit: 50,
        contextObject: contextObject,
        excludeRelatedToObject: undefined,
        includeEdges: false,
        includeNodes: true,
        adjacencyType,
        objectTypeId: objectTypeId ?? '',
        queryType: QueryTypes.LIST_LIMITED_ALL_TYPES,
    };
    const query = async (fn, contextRequest) => {
        debug && console.log('MultipleObjectAutoComplete query request', contextRequest);
        try {
            setLoading(true);
            const response = await ApiGateway.post(`/query/`, contextRequest, apiRef);
            if (response.data?.Items) {
                response.data.Items = response.data.Items.map((zombie) => Assembler.getInstance(zombie));
            }
            debug && console.log('MultipleObjectAutoComplete query results', response);
            fn(response);
            setLoading(false);
        }
        catch (e) {
            debug && console.log('Error in UM query', e);
        }
    };
    const queryHook = useDocumentClientQuery(query, queryParams, [contextObject, objectTypeId]);
    const [[items, setItems], [limit, setLimit], [LastEvaluatedKeys, setLastEvaluatedKeys], [ExclusiveStartKey, setExclusiveStartKey]] = queryHook.querySetterGetters;
    const notifiableEntitiesHash = getVOBListHash(items);
    useEffect(() => {
        if (contextObject?.type === 'Customer')
            setContextObject(contextObject);
    }, [contextObject?.sk]);
    useEffect(() => {
        debug && console.log('Used effect on VOB Hash');
    }, [notifiableEntitiesHash]);
    const componentMap = {
        entity: (_jsx(FormControl, { fullWidth: fullWidth, children: _jsx(Autocomplete, { value: currentEntities,
                freeSolo: false,
                id: 'selectEntity',
                style,
                size: 'small',
                loading,
                options: loading ? [] : items,
                multiple,
                disableCloseOnSelect: !closeOnSelect,
                filterSelectedOptions: true,
                getOptionLabel: (option) => option.name ?? noOptions,
                onChange: (e, v) => {
                    const update = v instanceof Array ? v : [v];
                    setCurrentEntities(update.filter((v) => v !== null));
                },
                renderInput: (params) => (_jsx(TextField, { ...params,
                    label: label ?? objectTypeId,
                    error: required && currentEntities.length === 0 })) }) })),
    };
    return componentMap.entity;
};
